import { render, staticRenderFns } from "./PerformanceInput.vue?vue&type=template&id=dfd903f4&scoped=true&"
import script from "./PerformanceInput.vue?vue&type=script&lang=js&"
export * from "./PerformanceInput.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceInput.vue?vue&type=style&index=0&id=dfd903f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd903f4",
  null
  
)

export default component.exports